/**
 * Helmet for Track
 */

import tr from '../../../locales';
import { getResponsiveAssets } from '../../../utils/image';
import { getOriginLocation } from '../../../utils/router';
import { twitterHandleFromURL } from '../../../utils/string';

import { template } from 'lodash';
import * as React from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';

interface IOwnStateProps {
  businessInformation: GQL.IBusinessInformation;
}

interface IOwnProps {
  track: GQL.ITrackSearchResult;
}

type TrackHelmetProps = IOwnStateProps & IOwnProps;

const defaultList = [];

function TrackHelmet(props: TrackHelmetProps) {
  const {
    track: {
      artist,
      assets,
      title,
    },
  } = props;

  const trackInfo = `${title} by ${artist!.name}`;
  const pageTitle = template(tr.pageTitles.artistAndTrackTemplate)({ entity: trackInfo });
  const coverAssets = getResponsiveAssets('thumb', assets || defaultList);
  const image = coverAssets.xlarge.find(({ format }) => format !== 'webp');
  const coverImagePath = `${getOriginLocation()}${image!.path}`;
  const imageHasMetadata = !!image && !!image.metadata;
  const description = template(tr.metaDescriptions.artistDefaultTemplate)({ artist: artist!.name });
  return (
    <Helmet titleTemplate={undefined}>
      <title>{pageTitle}</title>
      <meta name="description" property="og:description" content={description} />
      <meta property="og:determiner" content="an" />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:image" content={coverImagePath} />
      <meta property="og:image:type" content="image/jpeg" />
      {imageHasMetadata && [
        <meta key="og:image:width" property="og:image:width" content={image!.metadata.width.toString()} />,
        <meta key="og:image:width" property="og:image:height" content={image!.metadata.height.toString()} />,
      ]}
      <meta
        property="og:image:alt"
        content={`Cover art for track ${trackInfo} available on ${tr.pageTitles.default}`}
      />
      {!!artist!.twitter &&
        <meta name="twitter:creator" content={`@${twitterHandleFromURL(artist!.twitter!) || artist!.twitter}`}/>
      }
      <script type="application/ld+json">{`{
        "@context": "http://schema.org",
        "@type": "MusicRecording",
        "name": "${title}",
        "byArtist": {
          "@type": "MusicGroup",
          "name": "${artist!.name}",
          "description": "${description}"
        },
        "thumbnailUrl": "${coverImagePath}"
      }`}</script>
    </Helmet>
  );
}

const ConnectedTrackHelmet = connect<IOwnStateProps, {}, IOwnProps, IStoreState>(
  ({ staticData }) => ({
    businessInformation: staticData.businessInformation as GQL.IBusinessInformation,
  }),
)(TrackHelmet);

export default ConnectedTrackHelmet;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/pages/Track/helmet.tsx